export default __webpack_public_path__ + "static/lutein-shield-4236c585134c5251ce4dd74bb05b0fac.jpg";